import Vue from 'vue'
import AsyncComputed from 'vue-async-computed'
import Router from 'vue-router'
import VueClipboard from 'vue-clipboard2'
import auth from '@/plugins/auth'
import i18n from '@/plugins/i18n'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import store from '@/store'
import '@/main.css'

import App from '@/App.vue'

// uncomment the line below to get test data
// import './plugins/mock'

Vue.use(auth)
Vue.use(AsyncComputed)
Vue.use(Router)

Vue.config.productionTip = false
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
